import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const PosGuide = () => {
  return (
    <Style>
      <div className="contentContainer">
        <div className="posDownload">
          <h3>호텔 객실 스마트오더 솔루션</h3>
          <h2>새로운 개념의 룸서비스</h2>
          <h2>
            <span>노크노크 포스</span>를 무료로 다운받아보세요
          </h2>
          <a
            href="https://knock-knock.ivid.kr/gcs/installer-knockknock/knockknock-pos-exe/production/knockknock-pos_x86-setup.exe"
            target="_blank">
            노크노크 포스 다운받기
          </a>
        </div>
        <div className="guide">
          <h4>🔔 포스 사용방법 및 노크노크 안내사항을 쉽게 알려드릴게요 🔔</h4>
          <a href="https://www.youtube.com/watch?v=b312aw6dbMU&t=6s" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/svg/youtube.svg`} alt="유튜브" width={24} />
            <p>유튜브 동영상 가이드 보기</p>
          </a>
        </div>
        <div className="serviceCenter">
          <p>문제 발생시 원격 서비스를 지원해드려요</p>
          <a href="https://anydesk.com/ko/downloads/windows" target="_blank">
            포스에서 원격 지원 받기
          </a>
        </div>
      </div>
    </Style>
  );
};

export default PosGuide;

const Style = styled.div`
  h3 {
    font-size: 14px;
    font-weight: 300;
    color: #555;
  }
  h2 {
    font-size: 24px;
    font-weight: 600;
    line-height: 34px;
    color: #000;
  }
  h4 {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
  }
  p {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  span {
    font-weight: 700;
    color: #4dd2ae;
  }
  a {
    color: #333;
    font-weight: 400;
  }
  .contentContainer {
    height: calc(100vh - 200px);
    display: flex;
    flex-direction: column;
  }
  .posDownload {
    a {
      display: inline-block;
      margin-top: 10px;
      padding: 10px 30px;
      font-size: 20px;
      background: #4dd2ae;
      color: #fff;
      border-radius: 4px;
      font-weight: 600;
    }
    a:hover {
      background: #40977f;
    }
  }
  .guide {
    margin-top: 60px;
    a {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      margin-top: 18px;
      padding: 10px 20px;
      border-radius: 4px;
      border: 1px solid #555;
      p {
        font-size: 16px;
        color: #333;
      }
    }
    a:hover {
      background: #555;
      p {
        color: #fff;
      }
    }
  }
  .serviceCenter {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: auto;

    a {
      color: #40977f;
      text-decoration: underline;
    }
  }
`;
